import React from "react";

import { useAuthContextV2 } from "../../../../../auth-state";
import { KintoneExportSettingCreateContent } from "../../../../organisms/kintone-export/kintone-export-setting-create-content/kintone-export-setting-create-content";
import { useKintoneExportCreatePage } from "../page-hooks/kintone-export-setting-create/hook";
import { KintoneExportR } from "../routes";
import { KintoneExportTemplate } from "../template";

export const KintoneExportSettingCreatePage: React.FC = () => {
  const { auth } = useAuthContextV2();
  const {
    input,
    setInput,
    selectedSmartApplyProcedure,
    kintoneAppUrl,
    isLoading,
    showDialog,
    showValidationErrorMessage,
    showKintoneApiErrorMessage,
    showNoEmailUserInGroupErrorMessage,
    onClickCreateOnPage,
    onClickCreateOnDialog,
    onClickCancelOnDialog,
  } = useKintoneExportCreatePage({
    tenantId: auth.data?.orgId,
    detailLinkProvider: KintoneExportR.KintoneExportSettingDetail.link,
  });

  return (
    <KintoneExportTemplate
      breadcrumbs={[
        {
          to: KintoneExportR.KintoneExportSettings.link({}),
          title: "連携設定一覧",
        },
        {
          to: KintoneExportR.KintoneExportSettingCreate.link({}),
          title: "新規連携設定",
        },
      ]}
    >
      <KintoneExportSettingCreateContent
        selectedProcedure={selectedSmartApplyProcedure}
        kintoneAppUrl={kintoneAppUrl}
        isLoading={isLoading}
        showDialog={showDialog}
        showValidationErrorMessage={showValidationErrorMessage}
        showKintoneApiErrorMessage={showKintoneApiErrorMessage}
        showNoEmailUserInGroupErrorMessage={showNoEmailUserInGroupErrorMessage}
        onClickCreateOnPage={onClickCreateOnPage}
        onClickCreateOnDialog={onClickCreateOnDialog}
        onClickCancelOnDialog={onClickCancelOnDialog}
        createKintoneExportSettingInput={input}
        onChange={setInput}
      />
    </KintoneExportTemplate>
  );
};
